// extracted by mini-css-extract-plugin
module.exports =  {"container":"SurveyWaffle-module__container--gkqbr","circle":"SurveyWaffle-module__circle--OJ4U3","circleFilled":"SurveyWaffle-module__circleFilled--FAaaJ"};